import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { boxTypesWithFormattedPricesSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { chooseBoxType, onCloseBoxBuilderPopup, saveBoxType, selectBackButton } from '../../../../../redux/box-builder/box-builder.actions';
import { STEPS } from '../../../../../redux/box-builder/box-builder.constants';
import { hasUnsavedChangesSelector, isEditingBoxTypeBoxIdSelector, selectedOrExistedBoxTypeSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import { BoxTypeSelectionComponent } from './box-type-selection';
const mapStateToProps = createStructuredSelector({
  isBoxTypeEdit: isEditingBoxTypeBoxIdSelector,
  selectedBoxType: selectedOrExistedBoxTypeSelector,
  boxTypes: boxTypesWithFormattedPricesSelector,
  hasUnsavedChanges: hasUnsavedChangesSelector
});
const mapDispatchToProps = dispatch => ({
  onNext: type => {
    dispatch(saveBoxType(type));
  },
  onChange: type => {
    dispatch(chooseBoxType(type));
  },
  onBackButton: (isExit, hasUnsavedChanges) => {
    if (isExit) {
      dispatch(onCloseBoxBuilderPopup(dispatch)(hasUnsavedChanges));
    } else {
      dispatch(selectBackButton(STEPS.BOX_TYPE_SELECTION));
    }
  }
});
export const BoxTypeSelection = connect(mapStateToProps, mapDispatchToProps)(BoxTypeSelectionComponent);